import { AcceptedCurrencyCode } from '../../types/__generated-graphQL__';
import { formatCurrency } from './currencyFormatting';

const getTotalRaised = (
  currencyCode?: AcceptedCurrencyCode,
  totalRaised?: { amounts: { unit: string; value: number }[] } | null,
) => {
  if (!totalRaised)
    return formatCurrency({
      currencyCode,
      amount: 0,
      alwaysShowFractions: true,
    });
  const amountInCurrency = totalRaised.amounts.filter(({ unit }) => {
    return unit.toUpperCase() === currencyCode;
  });

  return formatCurrency({
    currencyCode,
    amount: amountInCurrency[0].value ?? 0,
    alwaysShowFractions: true,
  });
};

export default getTotalRaised;
